/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GenericApiResponseBody } from './generic-api-response-body';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';

//<custom-head>
import { GenericApiResult } from '../results';
import { HttpResponse } from '@angular/common/http';
//</custom-head>

/**
 * Generic API response for sending a failure response or empty success.
 * 
 * @typeParam TResult -
 */
export class GenericApiResponse<TResult> extends ResponseWithErrorGeneric<GenericApiResponseBody<TResult>, TResult> implements IResponseWithErrorGeneric<TResult> {
  public modelState: { [key: string]: string[]; };

  //<custom-body>
  constructor(response: HttpResponse<GenericApiResponse<TResult>>) {
    super(response, <TResult><any>GenericApiResult.Error);
  }
  //</custom-body>
}
